export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/hotel-image-2x-192492987e3c174ed87ed25289fe43c7.webp";